import React, { Fragment, useState, useRef, useEffect } from 'react';
import { Estruturas, Loader } from "../index";
import { Col, Row } from "reactstrap";
import { MenuTable } from '../../Menu';
import { iniciarValorPadrao, create_UUID } from '../funcoes';
import { axiosApi } from '../axiosInstances';
import ModalAtualizarAula from '../../Modal/ModalAtualizarAula';
import { connect } from 'react-redux';
import * as actionsRedux from '../../Store/Actions/index';

const GerarEstrutura = ({
    iconAdicionar,
    iconRemover,
    iconSalvar,
    iconRemoverLocal,
    estruturaPadrao,
    valorPadrao,
    submit,
    formularioGeral,
    adicionarOnClick,
    salvarLocal,
    removerLocal,
    removerOnClick,
    onChangeEstrutura,
}) => {
    return (
        <Fragment>
            <Col xs={9} sm={10} md={10} lg={11} xl={11}>
                <Row>
                    <Estruturas
                        estrutura={iniciarValorPadrao(estruturaPadrao, valorPadrao)}
                        submit={submit}
                        formularioGeral={formularioGeral}
                        onChange={onChangeEstrutura}
                    />
                </Row>
            </Col>
            <Col xs={3} sm={2} md={2} lg={1} xl={1}>
                <MenuTable
                    iconRemover2={iconRemover}
                    iconAdicionar={iconAdicionar}
                    iconSalvar={iconSalvar}
                    iconRemoverLocal={iconRemoverLocal}
                    removerOnClick={removerOnClick}
                    adicionarOnClick={adicionarOnClick}
                    salvarLocal={salvarLocal}
                    removerLocal={removerLocal}
                    containerStyle={{ height: '100%' }}
                />
            </Col>
        </Fragment>
    );
};

const ReplicarForm = ({
    ativar,
    name,
    estruturaPadrao,
    submit,
    onChange,
    valorAtual,
    formularioGeral,
    valorPadrao = [{}],
    ativarModalConfirm
}) => {
    const [quantidadeDeEstrutura, setQuantidadeDeEstrutura] = useState(valorPadrao.length === 0 ? 1 : valorPadrao.length);
    const formulario = useRef(valorPadrao.length === 0 ? [{}] : valorPadrao);
    const estruturas = [];
    const [modalAtualizacao, setModalAtualizacao] = useState(false);
    const [conflitoConfirmado, setConflitoConfirmado] = useState(false);
    const posicao = useRef();
    const [loader, setLoader] = useState(false);
    const [periodosLetivos, setPeriodosLetivos] = useState([]);

    useEffect(() => {
        if (name === 'locais' || name === 'atividades' || name === 'horarios') {
            const fetchPeriodos = async () => {
                try {
                    const response = await axiosApi.get('/auxiliares/local-semestre/periodos-letivos');
                    setPeriodosLetivos(response.data.dados);
                } catch (error) {
                    console.error("Erro ao buscar períodos letivos", error);
                }
            };
            fetchPeriodos();
        }
    }, [name]);

    const adicionarOnClick = () => {
        formulario.current.push({});
        setQuantidadeDeEstrutura(quantidadeDeEstrutura + 1);
    }

    const removerOnClick = (indice) => {
        formulario.current.splice(indice, 1);
        setQuantidadeDeEstrutura(quantidadeDeEstrutura - 1);

        if (valorAtual) {
            onChange(name, formulario.current.slice());
        }
    };

    const removerOnClickLocal = async (indice) => {
        try {
            setLoader(true);
            await axiosApi.delete(`/auxiliares/local-semestre?semestre_id=${formulario.current[indice].semestre_id}&tipo_atividade_id=${formulario.current[indice].tipo_atividade_id}&turma=${formulario.current[indice].turma}`, formulario.current[indice]);
            adicionarOnClick();
            ativar(201, 'Local removido com sucesso.')
            removerOnClick(indice);
        } catch (error) {
            ativar(400, 'Algo deu errado.')
        } finally {
            setLoader(false);
            setModalAtualizacao(false);
        }
    }

    const salvarLocal = async (indice) => {
        posicao.current = indice;
        try {
            setLoader(true);
            const vigente = periodosLetivos.find(p => p.vigente) || periodosLetivos[0];
            const dadosCheck = {
                ...formulario.current[posicao.current],
                abreviatura_curso: formularioGeral.abreviatura,
                periodo_letivo_id: vigente?.id,
                check_only: true
            };
            
            // 1. Verificar conflitos primeiro
            const response = await axiosApi.post(`/auxiliares/local-semestre`, dadosCheck);
            
            setLoader(false);

            if (response.data.requer_confirmacao) {
                ativarModalConfirm({
                    titulo: "Confirmação de Conflitos",
                    mensagem: response.data.aviso,
                    size: 'lg',
                    callback: () => {
                        setConflitoConfirmado(true);
                        decidirModalPeriodo();
                    }
                });
            } else {
                setConflitoConfirmado(false);
                decidirModalPeriodo();
            }
        } catch (error) {
            setLoader(false);
            console.error("Erro ao verificar conflitos", error);
            ativar(400, 'Erro ao verificar conflitos.');
        }
    }

    const decidirModalPeriodo = () => {
        const vigente = periodosLetivos.find(p => p.vigente) || periodosLetivos[0];
        if (periodosLetivos.length > 1) {
            // Se tem mais de um período, mostra o modal completo (Período + Hoje)
            setModalAtualizacao(true);
        } else {
            // Se tem apenas um (o vigente), pergunta apenas sobre atualizar hoje
            ativarModalConfirm({
                titulo: "Atualizar Aulas",
                mensagem: "Deseja atualizar as aulas de hoje?",
                callback: () => atualizarAula(true, true, vigente?.id), // SIM para hoje
                callbackCancel: () => atualizarAula(false, true, vigente?.id) // NÃO para hoje
            });
        }
    }

    const atualizarAula = async (atualizaHoje, confirmar = false, periodoLetivoId = null) => {
        console.log(`atualizarAula chamado - atualizaHoje: ${atualizaHoje}, confirmar: ${confirmar}, periodoLetivoId: ${periodoLetivoId}`);
        try {
            setLoader(true);
            var dados = {
                ...formulario.current[posicao.current],
                abreviatura_curso: formularioGeral.abreviatura,
                atualiza_hoje: atualizaHoje,
                confirmar: confirmar || conflitoConfirmado,
                periodo_letivo_id: periodoLetivoId
            }
            const response = await axiosApi.post(`/auxiliares/local-semestre`, dados);
            
            if (response.data.requer_confirmacao) {
                setLoader(false);
                ativarModalConfirm({
                    titulo: "Confirmação de Local",
                    mensagem: response.data.aviso,
                    size: 'lg',
                    callback: () => atualizarAula(atualizaHoje, true, periodoLetivoId)
                });
                return;
            }

            if (response.data.aviso) {
                ativar(203, response.data.aviso)
            } else {
                ativar(201, 'Local adicionado com sucesso.')
            }
        } catch (error) {
            ativar(400, error.response.data.error)
        } finally {
            setModalAtualizacao(false);
            setLoader(false);
            setConflitoConfirmado(false);
        }
    }

    const retornarKeyEstrutura = (indice) => {
        formulario.current[indice].componentId = formulario.current[indice].componentId ? formulario.current[indice].componentId : create_UUID();
        return formulario.current[indice].componentId;
    };

    const onChangeEstrutura = (formularioEstrutura, formularioIncompleto, indice, invalidar) => {
        if (formularioIncompleto) {
            onChange(name, "");
            // dispatch();
        } else {
            formulario.current[indice] = { componentId: formulario.current[indice].componentId, ...formularioEstrutura };
            onChange(name, formulario.current.slice());
        }

        //TODO: Algoritmo para invalidar aqui
        if (formularioEstrutura && formularioEstrutura['inicio'] === '12:22') {
            invalidar('dia_da_semana')
            invalidar('inicio')
        }
    };

    for (let indice = 0; indice < quantidadeDeEstrutura; indice++) {
        let iconAdicionar = quantidadeDeEstrutura === indice + 1;
        let iconRemover = quantidadeDeEstrutura !== indice - 1;
        estruturas.push(
            <GerarEstrutura
                estruturaPadrao={estruturaPadrao}
                valorPadrao={formulario.current[indice]}
                submit={submit}
                indice={indice}
                iconRemover={name == "locais" ? false : iconRemover}
                iconRemoverLocal={name == "locais" ? true : false}
                iconAdicionar={iconAdicionar}
                iconSalvar={name == "locais" ? true : false}
                removerOnClick={() => removerOnClick(indice)}
                adicionarOnClick={adicionarOnClick}
                salvarLocal={() => salvarLocal(indice)}
                removerLocal={() => removerOnClickLocal(indice)}
                formularioGeral={formularioGeral}
                onChangeEstrutura={(formularioEstrutura, incompleto, formularioIncompleto, invalidar) => onChangeEstrutura(formularioEstrutura, formularioIncompleto, indice, invalidar)}
                key={retornarKeyEstrutura(indice)}
            />
        );
    };

    return (
        <>
            {loader && <Loader overlay={true} />}
            <ModalAtualizarAula 
                isOpen={modalAtualizacao} 
                atualizarAula={atualizarAula} 
                periodosLetivos={periodosLetivos}
            />
            <Col sm={12}>
                <Row>{estruturas}</Row>
            </Col>
        </>
    );
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        ativar: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao)),
        ativarModalConfirm: (dados) => dispatch(actionsRedux.ativarModalConfirm(dados)),
    }
}
export default connect(null, mapDispatchToProps)(ReplicarForm)